import { useRef } from 'react'
import BrandedFeedPreview from '../BrandedFeedPreview'
import { Drawer } from '../common'
import styles from './PostComposer.module.css'


function PreviewContent({ branding, item, testId }) {
  return (
    <BrandedFeedPreview
      branding={branding}
      item={item}
      initialMode="card"
      testId={testId}
      chrome={false}
    />
  )
}

export default function PostPreviewPanel({
  branding,
  item,
  mobileOpen,
  onMobileOpen,
  onMobileClose,
  mobileTriggerRef,
  panelRef,
  testId = 'post-creator-preview',
}) {
  const internalMobilePreviewTriggerRef = useRef(null)
  const resolvedMobilePreviewTriggerRef = mobileTriggerRef || internalMobilePreviewTriggerRef

  return (
    <>
      <aside ref={panelRef} className={styles.previewPanel}>
        <PreviewContent
          branding={branding}
          item={item}
          testId={testId}
        />
      </aside>

      {!mobileTriggerRef ? (
        <button
          ref={internalMobilePreviewTriggerRef}
          type="button"
          className={styles.mobilePreviewToggle}
          onClick={onMobileOpen}
        >
          Open Preview
        </button>
      ) : null}

      <Drawer
        open={mobileOpen}
        title="Live preview"
        description="Preview the current post card."
        side="right"
        onClose={onMobileClose}
        returnFocusRef={resolvedMobilePreviewTriggerRef}
      >
        <PreviewContent
          branding={branding}
          item={item}
          testId={`${testId}-mobile`}
        />
      </Drawer>
    </>
  )
}
